import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'admin',
    component: () => import('../views/index.vue'),
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/Receive',
    name: 'Receive',
    component: () => import('../views/Receive.vue'),
  },
  {
    path: '/couponDetail',
    name: 'CouponDetail',
    component: () => import('../views/coupon/detail.vue'),
  },
  {
    path: '/coupon',
    name: 'Coupon',
    component: () => import('../views/coupon/index.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
  },
  {
    path: '/history-orders',
    name: 'HistoryOrders',
    component: () => import('../views/history-orders/index.vue'),
  },
  {
    path: '/invoice',
    name: 'Invoice',
    component: () => import('../views/invoice/index.vue'),
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

export default router;
